/* eslint-disable */
export class Conf {
    static idempiereUrl = "https://idtest.vecositalia.it/"
    static windowTitle = 'CERTIFICO'
    static buildNo = "20260115075739"
}
